import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { AgentDto, OtpChannelEnum } from '../../../../service/dto';
import { Callback } from '../../login.component';
import { NzModalService } from 'ng-zorro-antd/modal';
import { AuthService } from '../../../../service/auth.service';

@Component({
    selector: 'app-two-factor-auth',
    templateUrl: './two-factor-auth.component.html',
    styleUrls: ['./two-factor-auth.component.scss'],
    standalone: false
})
export class TwoFactorAuthComponent implements OnInit, OnDestroy {
    @Input() agent!: AgentDto;
    @Input() credentials!: { username: string, password: string };
    @Output() doUpdateState = new EventEmitter<Callback>();

    otpCode: string = '';
    countdown: number = 30;
    isEmailMode: boolean = true;
    isSubmitting: boolean = false;

    private timerInterval: any;

    constructor(
        private authService: AuthService,
        private modalService: NzModalService,
        private cdr: ChangeDetectorRef
    ) {}

    ngOnInit(): void {
        this.triggerOtp();
    }

    ngOnDestroy(): void {
        this.clearTimer();
    }

    triggerOtp(): void {
        const channel: OtpChannelEnum = this.isEmailMode ? 'Email' : 'Sms';
        console.log(`Sending OTP via ${channel}`);

        this.authService.doSendLoginOtp(this.credentials.username, this.credentials.password, channel).subscribe({
            next: () => {
                this.otpCode = '';
                this.startCountdown();
            },
            error: () => {
                this.modalService.error({ nzTitle: 'Error', nzContent: 'Failed to send OTP.' });
            }
        });
    }

    startCountdown(): void {
        this.clearTimer();
        this.countdown = 30;
        this.cdr.markForCheck();

        this.timerInterval = setInterval(() => {
            if (this.countdown > 0) {
                this.countdown--;
                this.cdr.markForCheck();
            } else {
                this.clearTimer();
                this.cdr.markForCheck();
            }
        }, 1000);
    }

    clearTimer(): void {
        if (this.timerInterval) {
            clearInterval(this.timerInterval);
        }
    }

    resendOtp(): void {
        if (this.countdown === 0) {
            this.triggerOtp();
        }
    }

    switchMethod(): void {
        this.isEmailMode = !this.isEmailMode;
        this.triggerOtp();
    }

    verifyOtp(): void {
        if (!this.otpCode) return;
        this.isSubmitting = true;

        this.authService.doAuthenticate(this.credentials.username, this.credentials.password!, this.otpCode)
            .subscribe(result => {
                this.isSubmitting = false;
                if(result.success==false){
					this.modalService.error({
                        nzTitle: 'Verification Failed',
                        nzContent: result.message || 'Invalid OTP.',
                        nzOkText: 'OK',
                        nzCentered: true
                    });
				}
            });
    }

    goBack(): void {
        this.doUpdateState.emit({ agent: this.agent, mode: 'Login' });
    }
}
